import AppProvider from 'providers/AppProvider';
import React from 'react';
import ReactDOM from 'react-dom/client';
import BreakpointsProvider from 'providers/BreakpointsProvider';
// import SettingsPanelProvider from 'providers/SettingsPanelProvider';
import { RouterProvider } from 'react-router-dom';
import { router } from 'Routes';
import SettingsPanelProvider from 'providers/SettingsPanelProvider';
// import ChatWidgetProvider from 'providers/ChatWidgetProvider';
// import * as serviceWorkerRegistration from './serviceWorkerRegistration'; // Service worker for caching and offline support

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <AppProvider>
      <SettingsPanelProvider>
        {/* <ChatWidgetProvider> */}
        <BreakpointsProvider>
          <RouterProvider router={router} />
        </BreakpointsProvider>
        {/* </ChatWidgetProvider> */}
      </SettingsPanelProvider>
    </AppProvider>
  </React.StrictMode>
);

// Register the service worker to enable caching and offline support
// serviceWorkerRegistration.register({
//   onSuccess: () => console.log('Service worker registered successfully.'),
//   onUpdate: () => {
//     console.log('New update available.');
//     // You can add additional logic to prompt users to refresh or install the app.
//   }
// });
